import React, { useState } from 'react'
import { useDebounce } from 'rooks'
import { captureException, captureMessage } from '@sentry/react'
import { useObservableImmutable } from '@core/Utils/hooks'
import { state$ } from '@core/State/UserAccount/userAccountDriver'
import { Button } from '@mobi/component-library/Base/Buttons'
import { ExpandableToolboxSection } from './Common/ExpandableToolboxSection'

export const Sentry = () => {
  const { accountNumber, isLoggedIn } = useObservableImmutable(state$, [
    'isLoggedIn',
    'accountNumber',
  ])
  const [sentTest, setSentTest] = useState(false)

  const clearTestFlag = useDebounce(() => setSentTest(false), 3000)

  const sendToSentry = (message: string | Error) => {
    const captureFn =
      typeof message === 'string'
        ? captureMessage.bind(null, message)
        : captureException.bind(null, message)

    captureFn(scope => {
      scope.clear()
      scope.setTag('is_test', true)
      if (isLoggedIn && accountNumber) {
        scope.setUser({
          id: accountNumber.toString(),
        })
      }
      return scope
    })

    setSentTest(true)
    clearTestFlag()
  }

  return (
    <ExpandableToolboxSection heading='Sentry' icon='DuocolorAlertTriangle'>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <Button size='xs' onClick={() => sendToSentry('This is a test message')}>
          Send test message
        </Button>
        <Button size='xs' onClick={() => sendToSentry(new Error('This is a test error'))}>
          Send test error
        </Button>
        {sentTest && <span>Test sent!</span>}
      </div>
    </ExpandableToolboxSection>
  )
}
